export const ApiPaths = {
  JobSeeker: {
    LookUpData: `/JobSeeker/GetLookups`,
    LookUpAllotmentData: (JsId: number) => `/JobAllotment/${JsId}`,
    JobDetailInitial: (JsId: number) => `/JobAllotment/JobDetail/${JsId}`,
    CreateProfile: `/JobSeeker/SaveProfile`,
    CreateProfessional: `/JobSeeker/SaveProfessional`,
    CreateReference: `/JobSeeker/SaveReference`,
    CreateSkill: `/JobSeeker/SaveSkills`,
    CreateContact: `/JobSeeker/SaveContact`,
    CreateDoc: `/JobSeeker/SaveDocs`,
    CreateDocument: `/JobSeeker/SaveUploadedDocs`,
    getJsList: '/JobSeeker/Search',
    getInitialJs: '/JobSeeker/InitialJs',
    getNonSubmittedJs: '/JobSeeker/NonSubmittedJs',
    UpdateStatus: '/JobSeeker/ChangeStatus',
    UploadeImage: '/JobSeeker/Upload',
    UploadeResume: '/JobSeeker/Resume',
    JobSeekerCondi: '/JobSeeker/GetInfo',
    JobList: `/JobSeeker/Search`,
    JobAllotmentList: `/JobAllotment/Search`,
    JsResumeExtract: `/JobSeeker/ParseResume`,
    JobDetailList: `/JobAllotment/SearchAllotedJobs`,
    SendInvitation: `/JobAllotment/Invite`,
    SendInvitationJS: `/JobAllotment/InviteJobSeeker`,
    loadProfessionalData: (JsId: number) => `/JobSeeker/GetProf/${JsId}`,
    loadReferenceData: (JsId: number) => `/JobSeeker/GetReference/${JsId}`,
    loadPreviewData: (JsId: number) => `/JobSeeker/GetPreview/${JsId}`,
    EvaluateJsForTP: (JsId: number) => `/JobSeeker/CheckCompatibilty/${JsId}`,
    loadJsJobAllotedList: (JobId:number) => `/JobAllotment/Load/${JobId}`,
    loadDocInfoData: (JsId:number) =>  `/JobSeeker/GetDocumentsType/${JsId}`,
    loadJSDocInfoData: (JsId:number) =>  `/JobSeeker/GetUploadedDoc/${JsId}`,
    getJsJobAllotedList:  '/JobAllotment/SearchSubmittedJs',
    UpdateJAStatus: '/JobAllotment/UpdateJAStatus',
    UnAssignJobseeker: '/JobAllotment/UnAssignJobseeker',
    DeleteReference: `/JobSeeker/DeleteRef`,
    DeleteContact: `/JobSeeker/DeleteContact`,
    supplierInvitation: '/JobAllotment/SuppierInvitation',
    loadTPSData: (JsId: number) => `/JobSeeker/TPS/${JsId}`,
    loadSearchTPSData: `/JobSeeker/GetCompatibility`,
    loadResumePath: (resumeName: string) => `/JobSeeker/GetResPath/${resumeName}`,
    getJsInvitationList:  '/JobAllotment/GetJsAllotedList',
    loadJobAllotedListJs: (JobId:number) => `/JobAllotment/JsListJob/${JobId}`,
    resendInvitation:  '/JobAllotment/ResendJsInvitation',
    InvitationAction:  '/JobAllotment/InvitationAction',
    GetMedia:  '/JobSeeker/GetMedia',
  },
};
